import React from 'react';
import classnames from 'classnames';
import styles from './page_container.module.scss';

type Props = {
  classNames?: string;
};

export const PageContainer: React.FC<Props> = ({
  children,
  classNames = '',
}) => (
  <div className={classnames(styles.container, classNames)}>{children}</div>
);
